import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {MapMarker,Email,Basketball,MovieRoll,BookOpen,Dumbbell,GamepadVariant} from 'mdi-material-ui';
import Grid from '@material-ui/core/Grid';

let hob = {"Watching Movies and Series":<MovieRoll color="primary"/>,"Reading":<BookOpen color="primary"/>,"Working Out":<Dumbbell color="primary"/>,"Video Games":<GamepadVariant color="primary"/>}
export default function About(){
    return(
        <div>
            <Typography component="div">
                <Box fontWeight="bold" fontSize={50} m={2}>
                    about me
                </Box>
                <Box textAlign="justify" fontSize={16} m={2} style={{color:'#a8a8a8'}}>
                    Motivated student of computer engineering, interested in the fields of machine learning and algorithms with exprience in robatic, reinforcement and supervised learning. Enthusiastic about math and theoritical concepts. Skilled at programming and web development with work exprience.
                </Box>

                <div style={{ display: "flex", alignItems: "center", marginLeft: 10,marginTop:40 }}>
                    <MapMarker color="primary" style={{ fontSize: 25 }} />
                    <Box fontSize={16} m={1} >
                        Tehran, Iran
                    </Box>
                </div>
                
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <Email color="primary" style={{ fontSize: 25 }} />
                    <Box  fontSize={16} m={1} >
                        amirhossein.hassankhani1997@gmail.com
                    </Box>
                </div>

                <div style={{ display: "flex", alignItems: "center", marginLeft: 10,marginTop:40 }}>
                    <Basketball color="primary" style={{ fontSize: 40 }} />
                    <Box fontWeight="bold" fontSize={30} m={1} >
                        hobbies and interests
                    </Box>
                </div>
                <Grid container>
                    {
                        Object.keys(hob).map(item => 
                            (<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <div style={{margin:10,display:"inline"}}>
                                    {hob[item]}
                                </div>
                                <Box fontSize={16} fontWeight="bold" m={1} style={{display:"inline",color:'#a8a8a8'}} >
                                    {item}
                                </Box>
                            </Grid>)
                        )
                    }
                </Grid>
            </Typography>
        </div>
    )
}